import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vpsPaid: null,
  monitoring: null,
};

export const ratesSlice = createSlice({
  name: 'rates',
  initialState,
  reducers: {
    setRatesVpsPaid: (state, action) => {
      state.vpsPaid = action.payload;
    },
    setRatesMonitoring: (state, action) => {
      state.monitoring = action.payload;
    },

    resetRates: () => initialState,
  },
});

export const {
  setRatesVpsPaid,
  setRatesMonitoring,

  resetRates,
} = ratesSlice.actions;

export default ratesSlice.reducer;
